import { useMemo } from 'react';

import { Flex } from 'components/flex';
import { capitalize } from 'utils/string';
import { formatPrice } from 'utils/helpers';

import * as Styles from './styles';
import { TotalCartProps } from './types';
import { getTotalCardData } from './config';

export const TotalCart = ({
  items,
  children,
  paymentMethods,
  ...props
}: TotalCartProps) => {
  const cards = useMemo(() => {
    if (items?.length) {
      return items;
    }

    return getTotalCardData({ ...props, paymentMethods });
  }, [items, props, paymentMethods]);

  return (
    <Styles.TotalCard>
      {cards.map(({ title, value, subtitle }) => (
        <Flex
          gap={8}
          alignItems="center"
          key={`${title}-${value}`}
          justifyContent="space-between"
        >
          <Flex gap={8} alignItems="center">
            <Styles.Title>{title}</Styles.Title>
            {subtitle}
          </Flex>
          <Styles.Title>{formatPrice(value, '$0.00')}</Styles.Title>
        </Flex>
      ))}
      {children && (
        <>
          <Styles.Divider />
          {children}
          {paymentMethods?.map((value) => (
            <Flex
              justifyContent="space-between"
              key={`${value.type}-${value.amount}`}
            >
              <Styles.Title>{capitalize(value.type)}</Styles.Title>
              <Styles.Title>{formatPrice(value.amount)}</Styles.Title>
            </Flex>
          ))}
        </>
      )}
    </Styles.TotalCard>
  );
};
